import {
  MiniMap,
  useReactFlow,
  type Rect,
  type XYPosition,
} from '@xyflow/react';

import { useChartOverflow } from './useChartOverflow';

interface ChartMinimapProps {
  nodes: ReadonlyArray<{ position: XYPosition }>;
  nodeSize: { width: number; height: number };
  contentBounds?: Rect;
}

// Inline values so they survive the consuming app's Tailwind content-scanner.
const MINIMAP_STYLE = {
  width: 160,
  height: 120,
  margin: 0,
  right: 12,
  bottom: 64,
  borderRadius: 8,
  border: '0.5px solid #DEDBD4',
  boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
  overflow: 'hidden',
};

const ChartMinimap = ({
  nodes,
  nodeSize,
  contentBounds,
}: ChartMinimapProps) => {
  const { setCenter, getZoom } = useReactFlow();
  const isOverflowing = useChartOverflow({ nodes, nodeSize, contentBounds });
  if (!isOverflowing) return null;
  return (
    <MiniMap
      position="bottom-right"
      style={MINIMAP_STYLE}
      bgColor="#FFFFFF"
      nodeColor="#A8A29A"
      maskColor="rgba(248, 246, 241, 0.55)"
      ariaLabel="Chart overview"
      pannable
      zoomable
      // Dragging pans; a click jumps the view to that spot.
      onClick={(_event, position) =>
        setCenter(position.x, position.y, { zoom: getZoom() })
      }
    />
  );
};

export { ChartMinimap };
